import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  style: {"white-space":"nowrap"},
  class: "v-tabular"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "v-tabular"
}
const _hoisted_10 = {
  key: 2,
  class: "v-tabular"
}
const _hoisted_11 = {
  key: 3,
  class: "v-tabular"
}
const _hoisted_12 = {
  key: 4,
  class: "v-tabular"
}
const _hoisted_13 = {
  key: 5,
  class: "v-tabular"
}
const _hoisted_14 = { key: 6 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "v-tabular"
}
const _hoisted_18 = {
  key: 3,
  class: "v-tabular"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.property.choices == null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.onlyImpact)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass({ changedResult: _ctx.property.oldNumberValue != null && _ctx.property.choices != null && (Math.abs(_ctx.property.numberValue - _ctx.property.oldNumberValue) > 0 && !_ctx.onlyCurrentValue), positiveResult: _ctx.property.oldNumberValue != null && _ctx.property.choices == null && (Math.abs(_ctx.property.numberValue - _ctx.property.oldNumberValue) >= 1 && _ctx.property.oldNumberValue - _ctx.property.numberValue < 0 && !_ctx.onlyCurrentValue), negativeResult: _ctx.property.oldNumberValue != null && _ctx.property.choices == null && (Math.abs(_ctx.property.numberValue - _ctx.property.oldNumberValue) >= 1 && _ctx.property.numberValue - _ctx.property.oldNumberValue < 0 && !_ctx.onlyCurrentValue) })
              }, [
                (_ctx.property.oldNumberValue != null && Math.abs(Math.round(_ctx.property.numberValue - _ctx.property.oldNumberValue,0)) > 0 && !_ctx.onlyCurrentValue )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                      _createElementVNode("span", _hoisted_2, [
                        (_ctx.property.dataType == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(((_ctx.property.numberValue - _ctx.property.oldNumberValue) > 0 ? "+" : ((_ctx.property.numberValue - _ctx.property.oldNumberValue) < 0 ? "-" : ""))) + _toDisplayString(_ctx.$filters.rounding(Math.abs(_ctx.property.numberValue - _ctx.property.oldNumberValue), _ctx.$i18n.locale, _ctx.property.roundingDigits)), 1))
                          : _createCommentVNode("", true),
                        (_ctx.property.dataType == 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(((_ctx.property.numberValue - _ctx.property.oldNumberValue) > 0 ? "+" : ((_ctx.property.numberValue - _ctx.property.oldNumberValue) < 0 ? "-" : ""))) + _toDisplayString(_ctx.$filters.percentage(Math.abs(_ctx.property.numberValue - _ctx.property.oldNumberValue), _ctx.$i18n.locale, _ctx.property.roundingDigits)), 1))
                          : _createCommentVNode("", true),
                        (_ctx.property.dataType == 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(((_ctx.property.numberValue - _ctx.property.oldNumberValue) > 0 ? "+" : ((_ctx.property.numberValue - _ctx.property.oldNumberValue) < 0 ? "-" : ""))) + _toDisplayString(_ctx.$filters.currency(Math.abs(_ctx.property.numberValue - _ctx.property.oldNumberValue), _ctx.$i18n.locale, _ctx.currency)), 1))
                          : _createCommentVNode("", true),
                        (_ctx.property.dataType == 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(((_ctx.property.numberValue - _ctx.property.oldNumberValue) > 0 ? "+" : ((_ctx.property.numberValue - _ctx.property.oldNumberValue) < 0 ? "-" : ""))) + _toDisplayString((_ctx.property.numberValue - _ctx.property.oldNumberValue)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.property.oldStringValue != null && _ctx.property.stringValue != _ctx.property.oldStringValue && !_ctx.onlyCurrentValue )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, " * "))
                  : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createTextVNode("   ", -1))
              ], 2))
            : _createCommentVNode("", true),
          (!_ctx.onlyImpact)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                style: _normalizeStyle({ backgroundColor: _ctx.property.rangeColor != null ? _ctx.getRangeColor(_ctx.property.rangeColor,_ctx.property.numberValue) : 'unset' }),
                class: _normalizeClass(_ctx.property.rangeColor != null ? 'tbdc-colorfield' : '')
              }, [
                ((_ctx.property.autoCalculateType != null || _ctx.output == true) && _ctx.property.numberValue == null && _ctx.property.dataType > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "0"))
                  : _createCommentVNode("", true),
                (_ctx.property.dataType == 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.property.stringValue), 1))
                  : _createCommentVNode("", true),
                (_ctx.property.dataType == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$filters.rounding(_ctx.property.numberValue, _ctx.$i18n.locale, _ctx.property.roundingDigits)), 1))
                  : _createCommentVNode("", true),
                (_ctx.property.dataType == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$filters.percentage(_ctx.property.numberValue, _ctx.$i18n.locale, _ctx.property.roundingDigits)), 1))
                  : _createCommentVNode("", true),
                (_ctx.property.dataType == 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$filters.currency(_ctx.property.numberValue, _ctx.$i18n.locale, _ctx.currency)), 1))
                  : _createCommentVNode("", true),
                (_ctx.property.dataType == 4)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.property.numberValue), 1))
                  : _createCommentVNode("", true),
                (_ctx.property.dataType == 5)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.property.numberValue == 1 ?  _ctx.$t("message.yes") : _ctx.$t("message.no")), 1))
                  : _createCommentVNode("", true)
              ], 6))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.property.choices != null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[1] || (_cache[1] = _createTextVNode("   ", -1)),
          (!_ctx.onlyImpact &&  _ctx.property.dataType == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.getChoice(_ctx.property.choices,_ctx.property.stringValue)), 1))
            : _createCommentVNode("", true),
          (!_ctx.onlyImpact &&  _ctx.property.dataType != 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.getChoice(_ctx.property.choices,_ctx.property.numberValue)), 1))
            : _createCommentVNode("", true),
          (_ctx.onlyImpact && _ctx.property.oldNumberValue != null && Math.abs(_ctx.property.numberValue - _ctx.property.oldNumberValue) > 0 && !_ctx.onlyCurrentValue )
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, " * "))
            : _createCommentVNode("", true),
          (_ctx.onlyImpact && _ctx.property.oldStringValue != null && _ctx.property.stringValue != _ctx.property.oldStringValue && !_ctx.onlyCurrentValue )
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, " * "))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}